var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"title text-block",class:{'is-first': _vm.isFirst}},[_vm._v(" "+_vm._s(_vm.item.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }